/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import http from '@/io.ox/core/http'

let cache = null

export async function get (key) {
  try {
    if (!cache) {
      cache = await http.GET({
        module: 'accountrecovery',
        params: {
          action: 'get'
        }
      })
    }
    return cache[key] || ''
  } catch (error) {
    console.error('Failed to fetch account recovery data.', error)
    return null
  }
}

export async function set (key, value) {
  const previousCache = cache
  try {
    cache = { ...cache, [key]: value }
    return await http.PUT({
      module: 'accountrecovery',
      params: {
        action: 'set'
      },
      data: cache
    })
  } catch (error) {
    cache = previousCache
    console.error('Failed to update account recovery data.', error)
    throw error
  }
}
